<script setup lang="ts">
import type { ComponentStyles } from 'types/index';
import type { UmbracoForm } from 'types/blocks';

const { isDesktop } = useLayout();

defineProps<{
  componentStyles: ComponentStyles;
  data: UmbracoForm;
}>();
</script>

<template>
  <div :class="{ 'narrow-container': isDesktop }">
    <h2
      v-if="data.headline"
      class="mb-4 max-w-full"
      :class="{ container: !isDesktop }"
    >
      {{ data.headline }}
    </h2>

    <BaseRte
      v-if="data.bodyText"
      :content="data.bodyText"
      class="mb-10"
      :class="{ container: !isDesktop }"
    />

    <BaseForm :form-data="data.formPicker" />
  </div>
</template>
